import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Import from project
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import DialogDelete from "../../Utils/DialogDelete";
import CapitalProvinceForm from "./CapitalProvinceForm";
import { DELETE_CAPITAL_PROVINCE } from "../../Schema/CapitalProvince";

export default function CapitalProvinceAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [deleteCapitalProvince] = useMutation(DELETE_CAPITAL_PROVINCE, {
    onCompleted: ({ deleteCapitalProvince }) => {
      setLoading(false);
      if (deleteCapitalProvince?.isSuccess === true) {
        setAlert(true, "success", deleteCapitalProvince?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteCapitalProvince?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteCapitalProvince({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        {/* <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip> */}
      </Stack>

      {openEdit && (
        <CapitalProvinceForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_capital_province")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
